import React from "react";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../../../Hero/HeroBanner";
import HeroPicBig from "../../../../../assets/medical/examinations/packages/terhesseg/terhesseg_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/terhesseg/terhesseg_banner_kicsi.png";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamContent from "../ExamContent/ExamContent";
import GoToPriceMultiple from "../GoToPrice/GoToPriceMultiple";
import ExamCTA from "../../ExamCTA/ExamCTA";

const ExamPackageTerhesseg = () => {
  const terhessegPackages = examinationPackages[2].contains;

  // Create structured data for pregnancy testing packages
  const pregnancyTestingStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Terhességi vizsgálat csomagok - Bálint Analitika",
    description:
      "A Bálint Analitika laboratórium terhességi vizsgálat csomagjai a várandósság különböző szakaszaira specializálva.",
    relevantSpecialty: ["Obstetrics", "PreventiveMedicine", "MaternalMedicine"],
    medicineSystem: "Conventional Medicine",
    usedToDiagnose: "Pregnancy health monitoring and complications",
    normalRange: "Varies by individual test",
    affectedBy: ["Pregnancy stage", "Maternal age", "Pre-existing conditions"],
    procedure: "Blood test panels specialized for different pregnancy stages",
    serviceProvider: {
      "@type": "MedicalBusiness",
      name: "Bálint Analitika Laboratórium",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Kondorfa utca 6.",
        addressLocality: "Budapest",
        postalCode: "1116",
        addressRegion: "XI. kerület",
        addressCountry: "HU",
      },
    },
    offers: {
      "@type": "Offer",
      availability: "InStock",
      priceCurrency: "HUF",
      priceSpecification: {
        "@type": "PriceSpecification",
        price: "Varies by package",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Terhességi vizsgálatok | Várandós laborvizsgálatok | Bálint Analitika
        </title>
        <meta
          name="description"
          content="Terhességi laborvizsgálatok és várandósgondozási csomagok a Bálint Analitika budapesti laboratóriumában. Biztonságos és pontos eredmények az egészséges várandósságért."
        />
        <meta
          name="keywords"
          content="terhességi vizsgálat, várandós laborvizsgálat, magzati szűrés, várandósgondozási csomag, terhességi teszt Budapest, várandós vérvétel"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/terhessegi"
        />
        <script type="application/ld+json">
          {JSON.stringify(pregnancyTestingStructuredData)}
        </script>
      </Helmet>

      <HeroBanner
        srcBig={HeroPicBig}
        srcSmall={HeroPicSmall}
        alt="Terhességi vizsgálatok és várandósgondozási laborvizsgálatok a Bálint Analitika laboratóriumban"
      />

      <main className="pregnancy-package-page">
        <div className="container">
          <header className="pregnancy-package-header">
            <h1 className="heading-primary">Terhességi vizsgálat csomagok</h1>
            <p className="base-p-text">
              A Bálint Analitika laboratórium speciális terhességi vizsgálat
              csomagokat kínál Budapest XI. kerületében, amelyek segítenek az
              anya és a magzat egészségének nyomon követésében a várandósság
              különböző szakaszaiban. Vizsgálataink támogatják a biztonságos
              terhességet és a korai problémák felismerését.
            </p>
          </header>

          <section className="pregnancy-package-content">
            <div className="pregnancy-packages-overview">
              <h2 className="heading-secondary">
                Várandósgondozási programjaink
              </h2>

              <div className="pregnancy-packages-grid">
                {terhessegPackages.map((packageItem, index) => (
                  <article key={index} className="pregnancy-package-item">
                    <ExamContent
                      title={packageItem.name}
                      suggestedTo={packageItem.suggestedTo}
                      items={packageItem.items}
                      isPackage={true}
                      itemType="https://schema.org/MedicalTest"
                    />
                  </article>
                ))}
              </div>
            </div>

            <div className="exam-package-benefits">
              <h3 className="heading-tertiary">
                A rendszeres terhességi vizsgálatok fontossága
              </h3>
              <p className="base-p-text">
                A várandósság során végzett rendszeres laborvizsgálatok
                segítenek az anyai és magzati egészség nyomon követésében,
                valamint az esetleges komplikációk korai felismerésében. A
                különböző trimeszterekre specializált vizsgálati csomagjaink a
                terhesség minden szakaszában a legfontosabb paramétereket
                ellenőrzik.
              </p>

              <h4 className="heading-tertiary">Vizsgálataink előnyei:</h4>
              <ul className="exam-package-base-list">
                <li>Várandósság megalapozott nyomon követése</li>
                <li>Terhességi komplikációk korai felismerése</li>
                <li>Magzati fejlődési rendellenességek szűrése</li>
                <li>Anyai egészség monitorozása</li>
                <li>Szakorvosi konzultáció az eredményekről</li>
              </ul>
            </div>

            <div className="pregnancy-package-actions">
              <GoToPriceMultiple />

              <div
                className="pregnancy-package-contact"
                itemScope
                itemType="https://schema.org/MedicalOrganization"
              >
                <h3 className="heading-tertiary">
                  Konzultáció és időpontfoglalás
                </h3>
                <p className="base-p-text">
                  Terhességi vizsgálatainkkal kapcsolatban szakértői
                  konzultációt biztosítunk.
                </p>
                <ExamCTA />
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ExamPackageTerhesseg;
